var m = require('mithril');
var prop = require('mithril/stream');
var buttonElement = require('../components/button');
var ToggleSwitch = require('../components/toggleSwitch');
var loaders = require('../layout/components/loaders');
var flash = require('../components/flash');

var state = {
  eventNotificationsEnabled: prop(null),
  showViewEvents: prop(null),
  retentionDays: prop(''),
  showViewEventsOnOnlineUsers: prop(null),
  loaded: prop(false),
  loading: true,
  saving: false,
  message: prop([]),
  error: prop([])
};

function resetAlerts() {
  state.message([]);
  state.error([]);
}

function setMessage(items) {
  state.message(items);
}

function setError(items) {
  state.error(items);
}

function loadSettings() {
  resetAlerts();
  state.loaded(false);
  state.loading = true;
  return loaders.requestWithLoader({
    loader: 'main',
    method: 'GET',
    url: '/api/v1/events/settings',
  })
  .then(function (res) {
    if (!res || typeof res !== 'object') {
      setError(['Failed to load event settings']);
      return;
    }
    state.eventNotificationsEnabled(!!res.eventNotificationsEnabled);
    var showViewEvents = !!res.showViewEvents;
    state.showViewEvents(showViewEvents);
    state.showViewEventsOnOnlineUsers(!!res.showViewEventsOnOnlineUsers);
    if (!showViewEvents) {
      state.retentionDays('30');
    } else {
      state.retentionDays(res.retentionDays != null ? String(res.retentionDays) : '');
    }
    state.loaded(true);
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to load event settings');
    setError([msg]);
  })
  .finally(function () {
    state.loading = false;
  });
}

function saveSettings() {
  resetAlerts();
  state.saving = true;
  var eventNotificationsEnabled = !!state.eventNotificationsEnabled();
  var showViewEvents = !!state.showViewEvents();
  var retention = parseInt(state.retentionDays(), 10);
  var payload = {
    eventNotificationsEnabled: eventNotificationsEnabled,
    showViewEvents: showViewEvents,
    retentionDays: showViewEvents ? (Number.isFinite(retention) ? retention : state.retentionDays()) : 30,
    showViewEventsOnOnlineUsers: !!state.showViewEventsOnOnlineUsers()
  };

  return loaders.requestWithLoader({
    loader: 'submit',
    method: 'PUT',
    url: '/api/v1/events/settings',
    body: payload
  })
  .then(function (res) {
    if (res && typeof res === 'object') {
      state.eventNotificationsEnabled(!!res.eventNotificationsEnabled);
      var updatedShowViewEvents = !!res.showViewEvents;
      state.showViewEvents(updatedShowViewEvents);
      state.showViewEventsOnOnlineUsers(!!res.showViewEventsOnOnlineUsers);
      if (!updatedShowViewEvents) {
        state.retentionDays('30');
      } else {
        state.retentionDays(res.retentionDays != null ? String(res.retentionDays) : state.retentionDays());
      }
    }
    setMessage(['Saved event settings']);
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to save event settings');
    setError([msg]);
  })
  .finally(function () {
    state.saving = false;
  });
}

var eventsSettings = {
  oninit: function () {
    return loadSettings();
  },
  view: function () {
    var loaded = state.loaded();
    var content = null;
    if (state.loading) {
      content = m('div.tc', [
        m('img.h1', { src: '/images/loading-bars.svg' })
      ]);
    } else if (loaded) {
      var eventNotificationsEnabled = !!state.eventNotificationsEnabled();
      var showViewEvents = !!state.showViewEvents();
      var showViewEventsOnOnlineUsers = !!state.showViewEventsOnOnlineUsers();
      content = m('div', [
        m('div.mb3', [
          m('div.flex.items-center.justify-between', [
            m('span', 'Event Notifications'),
            m(ToggleSwitch, {
              id: 'event-notifications-toggle',
              checked: eventNotificationsEnabled,
              ariaLabel: 'Event notifications',
              onchange: function () {
                state.eventNotificationsEnabled(!eventNotificationsEnabled);
              }
            })
          ])
        ]),
        m('div.mb3', [
          m('div.flex.items-center.justify-between', [
            m('span', 'Enable View Events'),
            m(ToggleSwitch, {
              id: 'show-view-events-toggle',
              checked: showViewEvents,
              ariaLabel: 'Enable view events',
              onchange: function () {
                var nextValue = !showViewEvents;
                state.showViewEvents(nextValue);
                if (!nextValue) {
                  state.retentionDays('30');
                }
              }
            })
          ]),
          m('div.f6.gray.mt1', 'Allows page view events to be queried and displayed.')
        ]),
        m('div.mb3', [
          m('label', 'View Event Retention Period (days)'),
          m('input.form-control.w4', {
            type: 'number',
            min: 1,
            value: state.retentionDays(),
            oninput: function (e) {
              state.retentionDays(e.target.value);
            }
          })
        ]),
        m('div.mb3', [
          m('div.flex.items-center.justify-between', [
            m('span', 'Show View Events on Online User\'s Page'),
            m(ToggleSwitch, {
              id: 'show-view-events-online-users-toggle',
              checked: showViewEventsOnOnlineUsers,
              ariaLabel: 'Show view events on online user\'s page',
              onchange: function () {
                state.showViewEventsOnOnlineUsers(!showViewEventsOnOnlineUsers);
              }
            })
          ]),
          m('div.f6.gray.mt1', 'Shows recent page view events on the Online Users page.')
        ]),
        m('div.mt2.flex.justify-end', [
          m(buttonElement, {
            label: state.saving ? 'Saving…' : 'Save',
            class: 'green',
            style: { minWidth: '33%' },
            func: saveSettings
          })
        ])
      ]);
    }
    return m('div', [
      m('h3.mt0', 'Events'),
      state.error() && state.error().length ? m(flash, { items: state.error(), bg: 'bg-red' }) : null,
      state.message() && state.message().length ? m(flash, { items: state.message(), bg: 'bg-green' }) : null,
      content
    ]);
  }
};

module.exports = eventsSettings;
